import PropTypes from 'prop-types'

import { Icon } from '../display/icon'

const CopyIcon = ({ label = 'Copy', ...rest }) => {
  return (
    <Icon
      label={label}
      {...rest}
      dangerouslySetGlyph={`<svg data-name="Layer 1" viewBox="0 0 300 300"><path d="M59 76.9h70.8l51.4 51.3v122.3a6.3 6.3 0 0 1-6.2 6H58.8a6.1 6.1 0 0 1-5.9-6.4V82.8a6.1 6.1 0 0 1 6.1-5.9m0-10a16 16 0 0 0-16.1 15.5v167.5a16.2 16.2 0 0 0 15.5 16.6H175a16.3 16.3 0 0 0 16.2-15.6V128.2a9.8 9.8 0 0 0-3-7l-51.3-51.4a9.9 9.9 0 0 0-7.1-2.9H59z" style="fill:#1d1d1b"/><path d="M250.1 208.5V86.6l-51.3-51.3h-70.6a6.1 6.1 0 0 0-6.4 5.9v167.3a6.1 6.1 0 0 0 5.9 6.4h116a6.2 6.2 0 0 0 6.4-5.9z" style="fill:#b1ce5f"/><path d="M127.9 35.3h70.9l51.3 51.3V209a6.2 6.2 0 0 1-6.2 5.9H127.7a6.1 6.1 0 0 1-5.9-6.4V41.2a6.1 6.1 0 0 1 6.1-5.9m0-10a16.1 16.1 0 0 0-16.1 15.5v167.5a16.2 16.2 0 0 0 15.5 16.6h116.6a16.2 16.2 0 0 0 16.2-15.6V86.6a9.9 9.9 0 0 0-3-7l-51.3-51.4a9.7 9.7 0 0 0-7-2.9h-70.9z" style="fill:#1d1d1b"/><path style="fill:#fff" d="M201.6 33v50.7h50.7L201.6 33z"/><path d="M252.3 88.7h-50.7a5 5 0 0 1-5-5V33a5 5 0 0 1 8.6-3.5l50.6 50.7a4.8 4.8 0 0 1 1.1 5.4 4.9 4.9 0 0 1-4.6 3.1zm-45.7-10h33.6l-33.6-33.6z" style="fill:#1d1d1b"/></svg>`}
    />
  )
}

CopyIcon.propTypes = {
  onClick: PropTypes.func,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.oneOf(['tiny', 'small', 'medium', 'large'])
}

export { CopyIcon }
